import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("TopMenu");

// Specify payload shape as generic type argument.
export const setTopMenuEntry = actionCreator<{nextentry: string}>('SET_TOP_MENU_ENTRY');
export const setTopMenuDropdownIsOpen = actionCreator<{isopen: boolean}>('SET_TOP_MENU_DROPDOWN');
export const setFullscreen = actionCreator<{fullscreenenable: boolean}>('SET_FULLSCREEN');
